/**
 * Facts the Terms of Use and Privacy Policy pages interpolate.
 * Bump `effectiveDate` whenever either document's substance changes.
 */
export const LEGAL = {
    company: 'Twenty Four-Seven Enterprises Inc.',
    tradeName: '24/7 Educational Services',
    brand: 'my247ed.com',
    mailingAddress: '2910 E 57th Ave #164, Spokane, WA 99223',
    governingState: 'Washington',
    phone: '(509) 448-0603',
    supportEmail: 'support@my247ed.com',
    smsNumber: '(866) 247-7979',
    effectiveDate: 'October 16, 2026',
};
